<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Input Record Data</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/datarecord">Input Record Data</Link>
                </li>
                <li v-if="parent && parent.label" class="breadcrumb-item active">
                  <Link :href="'/admin/datarecord/' + parent.parent_id" v-text="parent.label"></Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Input/Entri Indikator Satu Data</h4>
                  <p class="card-title-desc mb-0">Pengisian volume terhadap data element/indikator oleh operator.</p>
                </div>
              </div>

              <hr />

              <div class="table-responsive">
                <table class="table table-bordered mb-0">
                  <thead>
                    <tr>
                      <th rowspan="2" class="text-center">#</th>
                      <th rowspan="2">Element Data / Indikator</th>
                      <th rowspan="2">Formula</th>
                      <th rowspan="2">Satuan</th>
                      <th rowspan="2">Perubahan Terakhir</th>
                      <th rowspan="2" class="text-center">Aksi</th>
                    </tr>
                    <tr>
                      <th v-for="tahun in filter.tahun_range" class="text-center" :key="'head-tahun-mulai-' + tahun" v-text="tahun"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in elementsdata" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row">
                        <Link v-if="row.child_count" :href="'/admin/datarecord/' + row.id" v-text="row.label"></Link>
                        <span v-else v-text="row.label"></span>
                        <span class="badge rounded-pill bg-info ms-2" v-if="row.child_count">{{ row.child_count }} Subdata</span>
                      </td>
                      <td scope="row" class="text-center">
                        <span v-text="row.formula"></span>
                      </td>
                      <td scope="row">{{ row.satuan || '-' }}</td>
                      <td scope="row">{{ row.inputrecord_last ? new Date(row.inputrecord_last.updated_at).toLocaleString() : '-' }}</td>
                      <td scope="row" class="text-center">
                        <a class="p-0 btn btn-sm btn-link" @click="formShow(row)">Isi Data</a> |
                        <Link :href="'/admin/datarecord/' + row.id" class="p-0 btn btn-sm btn-link">Buka</Link> |
                        <a class="p-0 btn btn-sm btn-link" @click="review(row)">Chart</a>
                      </td>
                    </tr>
                    <tr v-if="elementsdata.length == 0">
                      <td scope="row" :colspan="6 + filter.tahun_range.length" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p class="mt-3 mb-2 text-muted"><i>* Doubel klik pada kolom tahun dan indikator untuk dapat mengisi data element!</i></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
    <modal :show="chart.show" @close="chart.show = false" :title="'Preview Indikator'" size="xl" backdrop="static">
      <template #default>
        <div class="mb-3">
          <select name="tipe" id="tipe" v-model="chart.type" class="form-select d-inline-block">
            <option value="bar">Bar Chart</option>
            <option value="pie">Pie Chart</option>
          </select>
        </div>
        <div class="mb-3 px-5">
          <canvas ref="chart"></canvas>
        </div>
      </template>
    </modal>
    <!-- pengisian record -->
    <modal :show="form.show" @close="form.show = false" :title="'Pengisian Record Data'" size="xl" backdrop="static">
      <template #default>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="width: 5%;">#</th>
                  <th>Tanggal</th>
                  <th class="text-center">Volume</th>
                  <th class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in form.records" :key="`record-${i}`">
                  <td v-text="i+1"></td>
                  <td>
                    <span v-if="row.id" v-text="row.waktu"></span>
                    <input v-else type="text" class="form-control form-control-sm" ref="inputanggal" v-model="form.waktu">
                  </td>
                  <td class="text-center">
                    <span v-if="row.id" v-text="row.volume"></span>
                    <input v-else type="number" class="form-control form-control-sm" v-model="form.volume">
                  </td>
                  <td v-if="row.id" class="text-center">
                    <a class="p-0 btn btn-sm btn-link" @click="formDelete(row.id)">Hapus</a>
                  </td>
                  <td v-else class="d-flex justify-content-center gap-2">
                    <button class="btn btn-sm btn-primary" @click="formAction()">Simpan</button>
                    <button class="btn btn-sm btn-outline-danger" @click="form.records.splice(i, 1)">Batal</button>
                  </td>
                </tr>
                <tr v-if="!form.records.filter(r => !r.id).length">
                  <td></td>
                  <td colspan="3">
                    <div class="d-grid">
                      <button class="btn btn-sm display-block btn-success" @click="formAdd()">Tambah</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import { Chart, registerables } from 'chart.js'
Chart.register(...registerables)
import flatpickr from 'flatpickr'
const iColors = ['#109618', '#FF9900', '#DC3912', '#990099', '#3B3EAC', '#22AA99', '#22AA99', '#316395', '#DD4477', '#66AA00', '#808000', '#B82E2E', '#0099C6', '#994499', '#E67300']
import 'flatpickr/dist/flatpickr.min.css'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    elementsdata: Array,
    parent: Object,
    flash: Object,
  },
  data() {
    return {
      chart_container: false,
      chart: {
        show: false,
        row: null,
        type: 'bar',
      },
      form: {
        show: false,
        readonly: false,
        id: false,
        element_id: false,
        waktu: '',
        volume: '',
        records: [],
      },
      master: {
        tahun_mulai: 0,
        tahun_sampai: 0,
        tahun_range: [],
      },
      filter: {
        tahun_mulai: 0,
        tahun_sampai: 0,
        tahun_range: [],
      },
    }
  },
  methods: {
    review(row) {
      this.chart.row = row
      this.chart.show = true
    },
    open() {

    },
    formShow(row) {
      this.form.element_id = row.id
      this.form.records = row.records
      this.form.show = true
    },
    formAdd() {
      this.form.records.push({ waktu: '', volume: '' })
      setTimeout(() => {
        flatpickr(this.$refs.inputanggal, {})
      }, 0);
    },
    formAction() {
      const form = {
        waktu: this.form.waktu,
        volume: this.form.volume,
      }
      if(this.form.id) {
        this.$inertia.put(`/admin/datarecord/${this.form.element_id}/${this.form.id}`, form)
      } else {
        this.$inertia.post(`/admin/datarecord/${this.form.element_id}`, form)
      }
    },
    formDelete(id) {
      if(confirm('Hapus record data?'))
        this.$inertia.delete(`/admin/datarecord/${this.form.element_id}/${id}`)
    },
    handleFlash() {
      const { success } = this.flash;
      if(success) {
        this.form.element_id = success.element_id;
        this.form.records = success.records;
        this.form.waktu = '';
        this.form.volume = '';
        setTimeout(() => {
          this.form.show = true
        }, 0);
      }
    },
    appendChart() {
      const { show, type, row } = this.chart
      if (this.chart_container) this.chart_container.destroy()
      if (show) {
        const datasets = []
        datasets.push({
          label: row.label,
          backgroundColor: type == 'pie' ? this.master.tahun_range.map((r, i) => iColors[i]) : '#0af',
          data: this.master.tahun_range.map((r) => (row.inputdata[r] ? row.inputdata[r] : 0)),
        })
        setTimeout(() => {
          this.chart_container = new Chart(this.$refs.chart, {
            type: type,
            data: {
              labels: this.master.tahun_range,
              datasets,
            },
            options: {},
          })
        }, 300) // tunggu sampai animasi modal kelar
      }
    }
  },
  watch: {
    chart: {
      handler() {
        this.appendChart()
      },
      deep: true,
    },
    flash: {
      handler() {
        this.handleFlash();
      },
      deep: true
    }
  },
  mounted() {
    // TODO: bug random kadang di panggil kadang ga
    Inertia.on('start', (event) => {
      this.handleFlash();
    })
  },
}
</script>


<style>
.entry-data {
  width: unset;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  border-radius: 0;
  overflow: unset;
}
</style>